import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

// Administrator-only, matching the endpoint: `ScheduledReportsController` raises
// `Pundit::NotAuthorizedError` for anyone else, because this setting decides who receives the
// whole account's figures by email. The route guard is the courtesy; the controller is the rule.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/scheduled-report'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'SCHEDULED_REPORT.TITLE',
        icon: 'send-clock',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'scheduled_report_settings',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
